import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import FiltterLead from "./FiltterLead";
import { agentColumns } from "../../tables/agentColumns";
import { agentLeadColumns } from "../../tables/agentLeadColumns";
import AdminDataTable from "../../components/common/AdminDataTable";
import LeadRemark from "./LeadRemark";

export default function ViewLead() {
  const PAGE_SIZE = 10;
      const [sortBy, setSortBy] = useState("createdAt");
      const [sortOrder, setSortOrder] = useState("desc");
      const [pageSize, setPageSize] = useState(PAGE_SIZE);
      const [page, setPage] = useState(1);
      const [totalPages, setTotalPages] = useState(1);
      const [listLoading, setListLoading] = useState(false);
      const token = localStorage.getItem("adminToken");
      const [leads, setLeads] = useState([]);
      const [filters, setFilters] = useState({});
      const [isRemarkOpen, setIsRemarkOpen] = useState(false);
      const [selectedRemarks, setSelectedRemarks] = useState([]);

      const API_URL = process.env.REACT_APP_BASE_URL_API || "";
      const baseName = window.location.pathname
                        .split("/")
                        .filter(Boolean)
                        .pop();

      const fetchLeads = async (
          pageIndex = 0,
          appliedFilters = filters
        ) => {
        setListLoading(true);
        try {
          const pageNumber = pageIndex + 1;

          const queryParams = new URLSearchParams({
                    page: pageNumber,
                    limit: pageSize,
                    sortBy,
                    sortOrder,
                    ...appliedFilters,
                  }).toString();


            const url = `${API_URL}/api/admin/lead/${baseName}?${queryParams}`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error("Failed to fetch leads");
            }

            const data = await response.json();
            setLeads(data.data);
            setTotalPages(data.pagination.totalPages);

            setListLoading(false);
        } catch (error) {
            console.error("Error fetching leads:", error);
            setListLoading(false);
        }
    };

    const handleDelete = async (row) => {
      const confirmDelete = window.confirm(
        `Are you sure you want to delete lead ${row.leadId ? "#" + row.leadId : row.name || ""}?`
      );
      if (!confirmDelete) return;

      try {
        const url = `${API_URL}/api/admin/lead/delete/${row._id}`;
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const resData = await response.json();
        if (response.ok && (resData.status || resData.success)) {
          alert(resData.message || "Lead deleted successfully");
          fetchLeads(page - 1, filters);
        } else {
          alert(resData.message || "Failed to delete lead");
        }
      } catch (error) {
        console.error("Error deleting lead:", error);
        alert("Failed to delete lead");
      }
    };

   const viewRemark = (row) => {
            setSelectedRemarks(row.remarks || []);
            setIsRemarkOpen(true);
          };

          const handleCloseRemark = () => {
            setIsRemarkOpen(false);
            setSelectedRemarks([]);
          };

          const columns = agentLeadColumns({
            handleDelete,
            PAGE_SIZE,
            viewRemark,
          });

    useEffect(() => {
        fetchLeads(page - 1, filters);
    }, [page, pageSize, sortBy, sortOrder]);

     const handleFilter = (newFilters) => {
                setFilters(newFilters);
                setPage(1); // reset page
                fetchLeads(0, newFilters);
              };

    const handleSort = (column) => {
            if (!column) return;

            if (sortBy === column) {
              setSortOrder(sortOrder === "asc" ? "desc" : "asc");
            } else {
              setSortBy(column);
              setSortOrder("asc");
            }
          };

  return (
    <div class="container body">
      <div class="main_container">
        <Sidebar />
        <Header pageTitle="View Lead" />
        {/* page */}
        <div className="right_col" role="main">
       
          {/* /top tiles */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>List</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>

              </ul>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              <div className="row">
                <div className="col-sm-12">
                  <FiltterLead onFilter={handleFilter} />
                  {/* filter end */}
                 
                   <AdminDataTable
                    columns={columns}
                    data={leads}
                    page={page}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    loading={listLoading}
                    onPageChange={setPage}
                    onPageSizeChange={(size) => {
                      setPageSize(size);  
                      setPage(1);         
                      fetchLeads(1, size); 
                    }}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    onSort={handleSort}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* bod card end */}
            <LeadRemark 
                    isOpen={isRemarkOpen}
                    onClose={handleCloseRemark}
                    remarkData={selectedRemarks}
            />
        </div>

        {/* page end */}
        <Footer />

      </div>
    </div>
  );
}